import React, { useEffect } from 'react';


const REACT_APP_ONE_SIGNAL_APP_ID = process.env.REACT_APP_ONE_SIGNAL_APP_ID


export const logoutUserFromOneSignal = async () => {
  try {
    if (!window.OneSignal || !REACT_APP_ONE_SIGNAL_APP_ID) {
      console.warn('[OneSignal] SDK not loaded');
      return;
    }

    await window.OneSignal.logout();
    console.log('[OneSignal] User logged out successfully.');
    localStorage.removeItem('onesignal_last_user');
    return "logout";
  } catch (error) {
    console.error('[OneSignal] Logout failed:', error);
    return null;
  }
};


export const loginUserToOneSignal = async (userId) => {
  try {
    if (!window.OneSignal) {
      console.warn('[OneSignal] SDK not loaded');
      return;
    }

    await window.OneSignal.login(userId);
    console.log('[OneSignal] User logged in:', userId);
    localStorage.setItem('onesignal_last_user', userId);
    return userId;
  } catch (error) {
    console.error('[OneSignal] Login failed for user:', userId, error);
    return null;
  }
};

export const setUserTags = async (tags = {}) => {
  try {
    if (!window.OneSignal || !window.OneSignal.User) {
      console.warn('[OneSignal] User API not available');
      return;
    }

    await window.OneSignal.User.addTags(tags);
    console.log('[OneSignal] Tags set successfully:', tags);
    return tags;
  } catch (error) {
    console.error('[OneSignal] Failed to set tags:', error);
    return null;
  }
};

const OneSignalComponent = ({ user }) => {
  const OneSignal = require("react-onesignal");
  const { id, attributes } = user || {};
  const { email, deleted, banned, profile = {} } = attributes || {};
  const { firstName, lastName, publicData = {} } = profile || {};
  const userId = id?.uuid;

  const isValidUser = !!userId && !!email && !deleted && !banned; 

  if (!isValidUser) {
    return <></>
  };

  const setupOneSignal = async () => {
    if (!window?.OneSignal || !isValidUser) return;

    if (!window.__oneSignalInitialized) {
      await window.OneSignal.init({
        appId: REACT_APP_ONE_SIGNAL_APP_ID,
        allowLocalhostAsSecureOrigin: true,
        serviceWorkerParam: { scope: "/static/" },
        serviceWorkerPath: "static/signal/OneSignalSDKWorker.js",
      });

      window.__oneSignalInitialized = true;
    }

    console.log(window.OneSignal.Notifications, '&&& &&& =>  window.OneSignal');


    const isPushSupported = window.OneSignal.Notifications["_permission"];
    const isPushGranted = window.OneSignal.Notifications["_permissionNative"] == "granted";

    if (!isPushGranted && isPushSupported) {
      console.log("[OneSignal] Prompting for permission");
      await window.OneSignal.Notifications.requestPermission();
    }

    const previousUserId = localStorage.getItem('onesignal_last_user');
    if (previousUserId && previousUserId !== userId) {
      await logoutUserFromOneSignal();
    }


    await loginUserToOneSignal(userId);

    await setUserTags({
      firstName,
      lastName,
      group_2768420: 'true',
    });

    console.log(window.OneSignal.User, '&&& &&& => window.OneSignal.User');

  };

  useEffect(() => {
    setupOneSignal();
  }, []);

  return null;
};

export default OneSignalComponent;
